import { isXOrY } from '../typeGuards/Channel';
export default function completeLegendConfig(channelType, channelDef) {
  if ('legend' in channelDef && channelDef.legend !== undefined) {
    return channelDef.legend;
  }

  return isXOrY(channelType) || channelType === 'Text' ? false : {};
}